import { render, staticRenderFns } from "./OffersV4.vue?vue&type=template&id=8f30dbaa&scoped=true"
import script from "./OffersV4.vue?vue&type=script&lang=js"
export * from "./OffersV4.vue?vue&type=script&lang=js"
import style0 from "./OffersV4.vue?vue&type=style&index=0&id=8f30dbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f30dbaa",
  null
  
)

export default component.exports